import { localizedStrings } from '@core/strings'
import React from 'react'
import { useModal } from '@common/GlobalModal'
import {
  DialogActions,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
} from '@common/material'
import { Text } from '@fundamentals'
import ClearIcon from '@mui/icons-material/Clear'
import { ModalDialogContainer } from '@common/modal'

interface ComponentType {
  onDiscard: () => void
}

export const UnsavedChangesProjectPlanZonesModal: React.FC<ComponentType> = ({
  onDiscard,
}) => {
  const { hideModal } = useModal()

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.unsavedChanges}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}
      >
        <Text>{localizedStrings.confirmLeave}</Text>
      </DialogContent>

      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button variant='outlined' onClick={hideModal}>
          {localizedStrings.cancel}
        </Button>
        <Button
          variant='contained'
          color='error'
          onClick={() => {
            hideModal()
            onDiscard()
          }}
        >
          {localizedStrings.discard}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}
